import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {PaymentScheduleEditForm} from "./PaymentScheduleEditForm";

export const PaymentScheduleEdit = (props: EditProps) => {
    return (
        <DefaultEdit {...props}>
            <PaymentScheduleEditForm />
        </DefaultEdit>
    );
};
